import { useQuery } from '@tanstack/react-query';
import { TaskCategory } from '@models/taskCategory.model';
import { taskCategoryService } from '@services/taskCategory';

export const TASK_CATEGORIES_QUERY_KEY = ['taskCategories'];
export const ACTIVE_TASK_CATEGORIES_QUERY_KEY = ['taskCategories', 'active'];

export const useTaskCategories = () => {
  return useQuery<TaskCategory[], Error>({
    queryKey: TASK_CATEGORIES_QUERY_KEY,
    queryFn: async () => {
      const categories = await taskCategoryService.getTaskCategories();
      return categories || [];
    },
    staleTime: 10 * 60 * 1000,
  });
};

export const useActiveTaskCategories = () => {
  return useQuery<TaskCategory[], Error>({
    queryKey: ACTIVE_TASK_CATEGORIES_QUERY_KEY,
    queryFn: async () => {
      const categories = await taskCategoryService.getActiveTaskCategories();
      return categories || [];
    },
    staleTime: 10 * 60 * 1000,
  });
};

export default useTaskCategories;
